export default __webpack_public_path__ + "static/media/image.cabbageapps-pvt-ltd.6358cb6b.png";